import { Registry } from '@bem-react/di';

import Button from './button';
import Icon from './icon';
import Link from './link';
import Select from './select';
import Spin from './spin';
import Textinput from './text-input';
import User from './user';

const registry = new Registry({ id: 'lego' });

registry
    .set('User', User)
    .set('Icon', Icon)
    .set('Link', Link)
    .set('Select', Select)
    .set('Button', Button)
    .set('Textinput', Textinput)
    .set('Spin', Spin);

export const legoRegistry = registry;
